import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupDialog } from '@app/Common/popup/popup.dialog';
import { TreeNode } from '../../../Models/tree-node';
import { SubmissionTypeConfigService } from './submission-type-config.service';
import { MatSidenavContainer, MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { AddSubmissionTypeComponent } from './add-submission-type/add-submission-type.component';
import { TreeComponent } from '../tree/tree.component';

@Component({
    selector: 'aw-submission-type-config',
    templateUrl: './submission-type-config.component.html',
    styleUrls: ['./submission-type-config.component.less'],
    imports: [MatSidenavContainer, MatSidenav, AddSubmissionTypeComponent, MatSidenavContent, TreeComponent]
})
export class SubmissionTypeConfigComponent {

    treeData: TreeNode[] = [];
    indicatorDefaults: any;
    indicatorList: any[];

    @ViewChild('editPanel') editPanel: any;

    mainStepId: string;
    submissionTypeConfigStepId = 'EnvironmentalIndicatorDetail';
    indicatorAlias = 'IndicatorAlias';
    moduleId: string;
    version: number;

    constructor(
        private dialog: MatDialog,
        private submissionTypeConfigService: SubmissionTypeConfigService) { }

    private deleteNode(node: TreeNode) {
        const dialogRef = this.dialog.open(PopupDialog);
        dialogRef.componentInstance.DialogTitle = 'Deleting node and its children.';
        dialogRef.componentInstance.DialogDescription = 'Are you sure?';
        dialogRef.componentInstance.DialogConfirmButtonText = 'Yes';
        dialogRef.componentInstance.DialogCancelButtonText = 'No';

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.Result) {
                this.submissionTypeConfigService.deleteNode(node);
            }
        });
    }

    private addChildNode(node: TreeNode) {
        this.editPanel.toggle();
    }

    closeForm(hasSaved: boolean) {
        this.editPanel.close();
    }
}
